<template>
 <page>
  
  <head-nav :title="$t('language.page_news')">
    <icon-button-hamburger slot="left"></icon-button-hamburger>
    <icon-button-home slot="right"></icon-button-home>
  </head-nav>


  <scroll-menu v-if="computeUserAccess">
     <!-- grey color D9D9D9-->
      <scroll-button color="#666666" v-if='showFeed("parents")'  :to="'/group/0/globalnews/parents/'" title="language.group_news_parents"></scroll-button>
      <scroll-button color="#666666" v-if='showFeed("group")'  :to="'/group/0/globalnews/group/'" title="language.group_news_group"></scroll-button>
      <scroll-button color="#666666" v-if='showFeed("mylist")'  :to="'/group/0/globalnews/mylist/'" title="language.group_news_my_messages"></scroll-button>
    </scroll-menu>



  <scroll-page :pull-reload="true">

    <page-padding>
      <button-action v-if="computeUserAccess" to="/group/0/news/0/add_item/" title="language.add_news_item" ></button-action>
   </page-padding>

   <list-news :news_id="0" :key="updateKey" :feed="feed"/>
    

   </scroll-page>
  </page>
</template>

<script>

import { mapState } from 'vuex';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import ScrollMenu from '../components/scrollMenu/ScrollMenu.vue';
import ScrollButton from '../components/scrollMenu/ScrollButton.vue';
import PagePadding from '../components/PagePadding';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import ListNews from '../components/news/ListNews';
import ScrollPage from '../components/ScrollPage.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';
 

export default {
  name: 'global-news-page',
  data:function(){
    return{
      feed:this.$route.params.feed,
      updateKey:0,
    }
  },
  computed:{
     ...mapState([
       'appSettings','loaded'
       ]),
      
       computeUserAccess(){
         
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }

         return false;
       }
  },
  components: {
    ButtonAction,
    ListNews,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    Page,
    ScrollPage,
    ScrollMenu,
    ScrollButton,
  },
  methods:{
      initFeed(){
        

      this.feed=this.$route.params.feed;

       if(this.feed=="init"){
         
      // redirect for each user
      
      switch(this.appSettings.user_level){
        case USER_LEVEL.PARENT:
          
          this.$router.push('/group/0/globalnews/parents/')
        break;
        case USER_LEVEL.STUDENT:
          
          this.$router.push('/group/0/globalnews/group/')
        break;
        case USER_LEVEL.ADMIN:
          
          this.$router.push('/group/0/globalnews/parents/')
        break;
        case USER_LEVEL.TEACHER:
          
          this.$router.push('/group/0/globalnews/parents/')
        break;
      }
   
   }
   
      //this.getGroupNewsId();
    },

      showFeed(type){
       
      switch(type){
        case "parents":
          if (this.appSettings.user_level==USER_LEVEL.PARENT) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.ADMIN) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.TEACHER) {return true;}
        break;
        case "group":
          if (this.appSettings.user_level==USER_LEVEL.ADMIN) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.TEACHER) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.STUDENT) {return true;}
        break;
        case "approval":
          if (this.appSettings.user_level==USER_LEVEL.ADMIN) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.TEACHER) {return true;}
        break;
        case "mylist":
          if (this.appSettings.user_level==USER_LEVEL.ADMIN) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.TEACHER) {return true;}
          if (this.appSettings.user_level==USER_LEVEL.STUDENT) {return false;}
        break;
      }

      return false;
    }
    
  },// methods{}
  created(){
     
  },
  mounted(){
    this.initFeed();
  },
  watch:{
    '$route.params.feed': {
        handler: function(feed) {
           this.feed=feed;
           this.updateKey=new Date().getTime();
           this.initFeed();
        }
      }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
